module.exports = __webpack_public_path__ + "static/media/upload.5d1c3ed0.svg";